import React from 'react'
import { Modal, Button } from '../../../../components';
import '../style';
import { WarningCircle, X } from '@phosphor-icons/react';

const VerificationFailModal = (props) => {
  const {
    title,
    content,
    onCtaClick,
    cta,
    isOpen,
    onClose,
  } = props;
  return (
    <Modal
      isOpen={isOpen} 
      onClose={onClose} 
      size="regular" 
      className="fail-modal"
    >
      <div className='flex flex-col'>
        <div className='flex flex-col gap-3'>
          <div className='flex justify-between items-center'>
            <WarningCircle size={48}
              color="#df1b41"
              weight="fill" />
            <X
              className='cursor-pointer'
              size={20}
              color="#101010"
              onClick={onClose}
            />
          </div>
          <div className='heading-16'>{title}</div>
        </div>
        <div className='text-grey-70 text-14 pt-2 pb-4'>{content}</div>
        {cta &&<Button onClick={onCtaClick}>{cta}</Button>}
      </div>
    </Modal>
  )
}

export default VerificationFailModal